import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map } from 'rxjs/operators';
import { PublicCustomerFactory } from './factories/public-customer.factory';
import { PublicCustomer } from './models/public-customer.model';
import { EnrichResource } from './resource.service';
import { Customer } from './models/customer.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CustomerFactory } from './factories/customer.factory';

@Injectable()
export class CustomerResource extends EnrichResource<Customer> {
  protected resource: string = 'customers';

  constructor(
    protected httpClient: HttpClient,
    protected customerFactory: CustomerFactory,
    private publicCustomerFactory: PublicCustomerFactory,
  ) {
    super(httpClient, customerFactory);
  }

  public getPublicCustomer(searchName: string): Observable<PublicCustomer> {
    let url: string = `${this.resourceUrlv2()}/${searchName}/public`;
    return this.httpClient.get(url).pipe(
      map(this.handlePublicCustomerResponse.bind(this)),
      catchError(() => of(null)));
  }

  private handlePublicCustomerResponse(response: Response) {
    return this.publicCustomerFactory.toModel(response);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/customer.resource.ts